const roomTypes = [
  {
    label: 'Asuinhuone',
    value: 'ASUINHUONE',
    slots: ['tila', 'tila_asuinhuone']
  },{
    label: 'Keittiö',
    value: 'KEITTIO',
    slots: ['tila', 'tila_keittio']
  },{
    label: 'WC',
    value: 'WC',
    slots: ['tila', 'tila_wc']
  },{
    label: 'Pesu-/kylpyhuone',
    value: 'PESUHUONE',
    slots: ['tila', 'tila_pesuhuone']
  },{
    label: 'Sauna',
    value: 'SAUNA',
    slots: ['tila', 'tila_sauna']
  }
]

const defaultRoomType = roomTypes[0]

const roofShapes = [
  {
    label: 'Harjakatto',
    value: 'HARJA',
    icon: require('../assets/kattomuoto/harja.png')
  },{
    label: 'Aumakatto',
    value: 'AUMA',
    icon: require('../assets/kattomuoto/auma.png')
  },{
    label: 'Mansardikatto',
    value: 'MANSARDI',
    icon: require('../assets/kattomuoto/mansardi.png')
  },{
    label: 'Pulpettikatto',
    value: 'PULPETTI',
    icon: require('../assets/kattomuoto/pulpetti.png')
  },{
    label: 'Porrastettu pulpettikatto',
    value: 'PORRASTETTU',
    icon: require('../assets/kattomuoto/porrastettu.png')
  },{
    label: 'Tasakatto',
    value: 'TASA',
    icon: require('../assets/kattomuoto/tasa.png')
  }
]

const defaultRoofShape = roofShapes[0]

const houseOperationTypes = [
  {
    label: 'Kellari',
    value: 'kellari',
    slots: ['talo', 'talo_kellari']
  },{
    label: 'Ikkunat ja ovet',
    value: 'ikkunat',
    slots: ['talo', 'talo_ikkunat']
  },{
    label: 'Muut rakenteet',
    value: 'rakenteet',
    slots: ['talo', 'talo_rakenteet']
  },{
    label: 'LVIS talotekniikka',
    value: 'lvis',
    slots: ['talo', 'talo_lvis']
  }
]

const roomShapes = [
  {
    value: 'NELIO',
    label: 'Neliö',
    icon: require('../assets/options/pohjanmuoto_nelio.png')
  },{
    value: 'SUORAKAIDE',
    label: 'Suorakaide',
    icon: require('../assets/options/pohjanmuoto_suorakaide.png')
  },{
    value: 'SUORAKAIDE_PITKA',
    label: 'Suorakaide pitkä',
    icon: require('../assets/options/pohjanmuoto_suorakaide_pitka.png')
  },{
    value: 'LIEVA_L',
    label: 'Lievä L',
    icon: require('../assets/options/pohjanmuoto_lieva_l.png')
  },{
    value: 'L',
    label: 'L muoto',
    icon: require('../assets/options/pohjanmuoto_l.png')
  },{
    value: 'KAPEA_L',
    label: 'Kapea L',
    icon: require('../assets/options/pohjanmuoto_kapea_l.png')
  },{
    value: 'MATALA_T',
    label: 'Matala T',
    icon: require('../assets/options/pohjanmuoto_matala_t.png')
  },{
    value: 'T',
    label: 'T-malli',
    icon: require('../assets/options/pohjanmuoto_t.png')
  }
]

const defaultRoomShape = roomShapes[1]

export {
  roomTypes,
  defaultRoomType,

  roomShapes,
  defaultRoomShape,

  roofShapes,
  defaultRoofShape,

  houseOperationTypes
};



// WEBPACK FOOTER //
// ./src/api/constants.js